import { render } from "./TextareaInput.vue?vue&type=template&id=0937b7ea&scoped=true&ts=true"
import script from "./TextareaInput.vue?vue&type=script&lang=ts"
export * from "./TextareaInput.vue?vue&type=script&lang=ts"

import "./TextareaInput.vue?vue&type=style&index=0&id=0937b7ea&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0937b7ea"]])

export default __exports__